import { render, staticRenderFns } from "./VesselAuditMain.vue?vue&type=template&id=081b7992&scoped=true&"
import script from "./VesselAuditMain.vue?vue&type=script&lang=js&"
export * from "./VesselAuditMain.vue?vue&type=script&lang=js&"
import style0 from "./VesselAuditMain.vue?vue&type=style&index=0&id=081b7992&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081b7992",
  null
  
)

export default component.exports